import '../MortgageBuyOrDie.css';

import React from 'react';
import { Typography } from '@vtblife/uikit';
import Icon from '@vtblife/uikit-icons';

import { cnMrtgBuyOrDie } from '../MortgageBuyOrDieModal';

export function MortgageBuyOrDieReason({
    text,
    type
}: {
    type: 'pos' | 'neg';
    text: string;
}) {
    const icon = type === 'pos' ? 'check-circle' : 'information-circle';

    return (<div className={cnMrtgBuyOrDie('reason')}>
        <i className={cnMrtgBuyOrDie('reason-type-icon-bg', { type })}>
            <Icon name={icon} />
        </i>
        <Typography>{text}</Typography>
    </div>);
}
